import { PureComponent } from 'react'

import { Block, Label, FieldMessage, TagsList, RestoreFieldButton } from '@/forms-legacy'

import { Props } from './typings'

export default class TagsListField extends PureComponent<Props> {
  render() {
    const {
      label,
      name,
      info,
      half = false,
      maxCount,
      wrappedInputProps,
      formProps: {
        input: { value, onChange },
        meta: { error, dirty, initial },
      },
      testid,
    } = this.props

    return (
      <Block half={half} error={!!error} dirty={!!dirty} data-testid={testid} data-trackid={testid}>
        <Label htmlFor={name}>
          {label}{' '}
          <RestoreFieldButton
            dirty={dirty}
            initial={initial}
            onChange={onChange}
            style={{ marginLeft: 12 }}
          />
        </Label>
        <TagsList
          type="single"
          {...wrappedInputProps}
          value={value}
          onChange={onChange}
          maxCount={maxCount}
        />
        {!!error && <FieldMessage error>{error}</FieldMessage>}
        {!error && !!info && <FieldMessage>{info}</FieldMessage>}
      </Block>
    )
  }
}
